export const callsData = [
  {
    id: 1,
    callId: "1234",
    leadCustomerId:"4321",
    callType: "Outgoing",
    callDate: "29 Sep 2023 04:15 pm",
    callDuration: "5 min 42 secs",
    callStatus: "Completed",
    agentName: "Jerald",
    recordingLink: "",
    nextFollowUp: "21 Oct 2023 04:15 pm",
    notes: "Deal is Closed",
    Action: "",
    key: "1",
  },
  {
    id: 2,
    callId: "6789",
    leadCustomerId:"9876",
    callType: "Incoming",
    callDate: "25 Sep 2023 04:15 pm",
    callDuration: "4 min 42 secs",
    callStatus: "Disconnected",
    agentName: "Jami",
    recordingLink: "",
    nextFollowUp: "21 Oct 2023 04:15 pm",
    notes: "Deal is Closed",
    Action: "",
    key: "2",
  },
  {
    id: 3,
    callId: "1234",
    leadCustomerId:"4321",
    callType: "Outgoing",
    callDate: "21 Sep 2023 04:15 pm",
    callDuration: "2 min 42 secs",
    callStatus: "Missed",
    agentName: "Theresa",
    recordingLink: "",
    nextFollowUp: "21 Oct 2023 04:15 pm",
    notes: "Deal is Closed",
    Action: "",
    key: "3",
  },
 
];
